import { render } from "./SubManagement.vue?vue&type=template&id=54ad3482&scoped=true&ts=true"
import script from "./SubManagement.vue?vue&type=script&lang=ts"
export * from "./SubManagement.vue?vue&type=script&lang=ts"

import "./SubManagement.vue?vue&type=style&index=0&id=54ad3482&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ad3482"]])

export default __exports__